import type { CardLabel } from '@naf-simba/sections-cards';

type PaywallDetails = {
  isAccessibleForUser?: boolean;
  labelText?: string;
};

/**
 * The member-exclusivity badge the retired `@naf/card-grid` drew through its
 * `memberLabel` prop.
 *
 * Simba's `Card` has a single label slot, so the badge keeps the top-right
 * corner it had before and takes precedence over any editorial label. Unlike
 * the old `MemberLabel` it does not change with `isAccessibleForUser` — the
 * badge marks the article as member content either way.
 */
export const getCardMemberLabel = (paywallDetails?: PaywallDetails): CardLabel | undefined =>
  paywallDetails
    ? {
        text: paywallDetails.labelText || 'For medlemmer',
        color: 'primary',
        position: 'top-right',
      }
    : undefined;
